import React, { useEffect, useState } from "react";
import ProgressBar from "@ramonak/react-progress-bar";
import {
  Box,
  Text,
  Alert,
  AlertIcon,
  VStack,
} from "@chakra-ui/react";

const MarketSentimentCard = () => {
  const [sentiment, setSentiment] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(true);

  const getMarketSentiment = async () => {
    setLoading(true);
    setError("");
    setSentiment("");

    try {
      const response = await fetch("https://gpt.blindfoldcapital.com/api/market-sentiment/", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          prompt: "Give me today's crypto market sentiment in 3 sentences.",
        }),
      });

      const data = await response.json();
      setSentiment(data.sentiment);
    } catch (err) {
      console.error("API call failed:", err);
      setError("Failed to fetch market sentiment.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      getMarketSentiment();
    }, 1000); // start request 1s after mount
    return () => clearTimeout(timer);
  }, []);

  return (
    <Box
      w="100%"
      maxW="500px"
      p={4}
      mt={2}
      mb={2}
      //borderWidth="1px"
      //borderRadius="md"
      //boxShadow="md"
      bg="block"
    >
      <VStack spacing={4} align="start" p={4} justify="center">
        {error && (
          <Alert status="error" fontSize="sm" w="100%">
            <AlertIcon />
            {error}
          </Alert>
        )}

        {loading && (
          <Box w="100%">
            <ProgressBar
              completed={100}
              isLabelVisible={false}
              height="6px"
              bgColor="#3182ce"
              baseBgColor="#e2e8f0"
              animateOnRender
            />
            <Text fontSize="xs" color="white" mt={1}>
              Loading market sentiment...
            </Text>
          </Box>
        )}

        {!loading && sentiment && (
          <Box bg="gray.50" p={3} borderRadius="md" w="100%">
            <Text fontSize="sm" whiteSpace="pre-wrap">
              {sentiment}
            </Text>
          </Box>
        )}
      </VStack>
    </Box>
  );
};

export default MarketSentimentCard;
